const { windowLoaded } = require('@grpn/document-states');
const { setShellEventOrRun } = require('./setShellEvent');
const checkExperiment = require('src/frontend/helper/experiment');
const loadAsyncJS = require('./m_loadAsyncJS');
const { unescape } = require('../underscore/unescape');

function loadGTM(gtmData) {
  checkExperiment('LS-4100-intentmedia-gtm', {
    Treatment() {
      window.dataLayer.push({ 'LS-4100-intentmedia-gtm': true });
    },
  });
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });
  const src = new URL('gtm.js', 'https://www.googletagmanager.com');
  if (gtmData.id) {
    src.searchParams.set('id', gtmData.id);
  }
  loadAsyncJS(src.toString());
}

function guardedInit() {
  let gtm = {};
  const gtmData = window.gtmData || {};
  const { c, e } = Cookie.get(['c', 'e']);
  const cCookie = c;
  const eCookie = e;

  if (gtmData.data) {
    try {
      gtm = JSON.parse(unescape(unescape(gtmData.data)));
    } catch (error) {}
  }

  if (cCookie && eCookie) {
    gtm.dl_user_id = cCookie;
    gtm.dl_email_sha256 = eCookie;
  }

  gtm.platform = gtmData.platform;
  window.dataLayer = [gtm];

  if (gtmData.enabled) {
    windowLoaded.then(() => {
      loadGTM(gtmData);
    });
  }
}

export function initGtm() {
  setShellEventOrRun(
    'ls-gtm',
    guardedInit,
    () => !(window.gtmData && window.gtmData.data)
  );
}
